import { render, staticRenderFns } from "./ClinicianPatientMeasureDetail.vue?vue&type=template&id=64ba052b"
import script from "./ClinicianPatientMeasureDetail.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientMeasureDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports